










































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

const retreatCouponModule = namespace("retreatCoupon");
@Component({})
export default class FaceCouponsSure extends Vue {
  value: Number = 0;
  retreatCouponMsg: any = JSON.parse(
    (sessionStorage as any).getItem("retreatCouponMsg")
  );
  mounted() {
    console.log(this.retreatCouponMsg);
    this.setActive();
  }
  setActive() {
    this.$store.commit("retreatCoupon/setSelectStep", 3);
  }
  backHome() {
    this.$router.push({ path: "/home" });
  }
}
